'use client'

import { TbCopy, TbBrandTelegram, TbBrandWhatsapp, TbBrandMessenger, TbBrandX } from 'react-icons/tb'
import { SOCIAL_SHARE_URLS, UI_CONSTANTS, DEFAULT_TEXTS } from '@/utils/blog/blogConstants'

/**
 * Компонент для кнопок социальных сетей
 * @param {Object} props
 * @param {string} props.title - Заголовок статьи
 * @param {string} props.description - Описание статьи
 * @param {string} props.categoryColor - Hex цвет категории
 * @param {string} props.language - Язык ('ru' или 'en')
 */
export default function ShareButtons({ title, description, categoryColor, language = 'ru', hideLabel = false, gf = false }) {
    const texts = language === 'ru' ? DEFAULT_TEXTS.RU : DEFAULT_TEXTS.EN

    const buttonStyle = gf ? undefined : {
        backgroundColor: categoryColor + UI_CONSTANTS.OPACITY_10_PERCENT,
        color: categoryColor
    }

    const buttonClassName = gf
        ? "gf-share-btn"
        : "flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 rounded-xl hover:opacity-80 transition-colors"

    // Копировать ссылку
    const handleCopyLink = () => {
        if (typeof window !== 'undefined') {
            if (navigator?.clipboard) {
                navigator.clipboard.writeText(window.location.href).then(() => {
                    // Показать уведомление об успешном копировании
                    const button = document.activeElement
                    const originalTitle = button.title
                    button.title = texts.LINK_COPIED
                    setTimeout(() => {
                        button.title = originalTitle
                    }, UI_CONSTANTS.NOTIFICATION_TIMEOUT)
                }).catch(() => {
                    // Fallback для старых браузеров
                    const textArea = document.createElement('textarea')
                    textArea.value = window.location.href
                    document.body.appendChild(textArea)
                    textArea.select()
                    document.execCommand('copy')
                    document.body.removeChild(textArea)
                })
            }
        }
    }

    // Поделиться в Telegram
    const handleTelegramShare = () => {
        if (typeof window !== 'undefined') {
            try {
                const titleForShare = title || texts.INTERESTING_ARTICLE
                const descriptionForShare = description || ''
                const text = descriptionForShare ? `${titleForShare} - ${descriptionForShare}` : titleForShare
                const url = window.location.href
                const telegramUrl = `${SOCIAL_SHARE_URLS.TELEGRAM}?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`
                window.open(telegramUrl, '_blank', 'noopener,noreferrer')
            } catch (error) {
                console.warn('Ошибка при открытии Telegram:', error)
            }
        }
    }

    // Поделиться в WhatsApp
    const handleWhatsAppShare = () => {
        if (typeof window !== 'undefined') {
            const text = `${title} - ${description}`
            const url = window.location.href
            window.open(`${SOCIAL_SHARE_URLS.WHATSAPP}?text=${encodeURIComponent(text + ' ' + url)}`, '_blank')
        }
    }

    // Поделиться в Facebook
    const handleFacebookShare = () => {
        if (typeof window !== 'undefined') {
            const url = window.location.href
            window.open(`${SOCIAL_SHARE_URLS.FACEBOOK}?u=${encodeURIComponent(url)}`, '_blank')
        }
    }

    // Поделиться в Twitter/X
    const handleTwitterShare = () => {
        if (typeof window !== 'undefined') {
            const text = `${title}`
            const url = window.location.href
            window.open(`${SOCIAL_SHARE_URLS.TWITTER}?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`, '_blank')
        }
    }

    return (
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4">
            {!hideLabel && (
                <span className="text-gray-600 font-medium text-sm sm:text-base">
                    {language === 'ru' ? 'Поделиться:' : 'Share:'}
                </span>
            )}
            <div className="flex items-center gap-2 sm:gap-3">
                {/* Копировать ссылку */}
                <button
                    onClick={handleCopyLink}
                    className={buttonClassName}
                    style={buttonStyle}
                    title={texts.COPY_LINK}
                >
                    <TbCopy className="w-5 h-5 sm:w-6 sm:h-6" />
                </button>

                {/* Telegram */}
                <button
                    onClick={handleTelegramShare}
                    className={buttonClassName}
                    style={buttonStyle}
                    title={texts.SHARE_TELEGRAM}
                >
                    <TbBrandTelegram className="w-5 h-5 sm:w-6 sm:h-6" />
                </button>

                {/* WhatsApp */}
                <button
                    onClick={handleWhatsAppShare}
                    className={buttonClassName}
                    style={buttonStyle}
                    title={texts.SHARE_WHATSAPP}
                >
                    <TbBrandWhatsapp className="w-5 h-5 sm:w-6 sm:h-6" />
                </button>

                {/* Facebook/Messenger */}
                <button
                    onClick={handleFacebookShare}
                    className={buttonClassName}
                    style={buttonStyle}
                    title={texts.SHARE_FACEBOOK}
                >
                    <TbBrandMessenger className="w-5 h-5 sm:w-6 sm:h-6" />
                </button>

                {/* Twitter/X */}
                <button
                    onClick={handleTwitterShare}
                    className={buttonClassName}
                    style={buttonStyle}
                    title={texts.SHARE_TWITTER}
                >
                    <TbBrandX className="w-5 h-5 sm:w-6 sm:h-6" />
                </button>
            </div>
        </div>
    )
}

